import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import "./EventDateAndLocation.scss";
import { truncateString } from "@qgiv/core-js";

const EventDateAndLocation = ({
    displayEventDateAndLocation,
    displayFormattedEventDateString,
    displayFormattedEventLocationString,
    displaySeparatorDot,
    formattedEventDateString,
    formattedEventLocationString,
    displayAddToCalendarButton,
    addToCalendarData,
}) =>
    displayEventDateAndLocation ? (
        <div className="event-date-and-location col col--12 col--no-top-gutter -text--center">
            {displayFormattedEventDateString && (
                <span className="-type--small">
                    <Icon
                        className="receipt-header__calendar-icon -margin-right--10 -margin-left--10 -color--system-medium-dark"
                        glyph="calendar-alt-regular"
                        type="FontAwesome"
                    />
                    {formattedEventDateString}
                </span>
            )}
            {/* Display the date and location on separate lines on narrow devices */}
            <br className="event-date-and-location__line-break" />
            {/* Add a dot between the date and location on wide devices */}
            {displaySeparatorDot && (
                <strong className="event-date-and-location__separator-dot -margin-left--10 -margin-right--10">
                    {" • "}
                </strong>
            )}
            {displayFormattedEventLocationString && (
                <span className="-type--small">
                    <Icon
                        className="receipt-header__calendar-icon -margin-right--10 -color--system-medium-dark"
                        glyph="location-dot-solid"
                        type="FontAwesome"
                    />
                    {formattedEventLocationString}
                </span>
            )}
            {displayAddToCalendarButton && (
                <>
                    <strong className="event-date-and-location__separator-dot -margin-left--10 -margin-right--10">
                        {" "}
                        •{" "}
                    </strong>
                    <button
                        type="button"
                        className="addeventatc -color--theme-primary -type--small"
                        data-styling="none"
                    >
                        Add to calendar
                        <span className="start">
                            {addToCalendarData.startDate}
                        </span>
                        <span className="end">{addToCalendarData.endDate}</span>
                        <span className="timezone">
                            {addToCalendarData.timezone}
                        </span>
                        <span className="title">{addToCalendarData.name}</span>
                        {!!addToCalendarData.description && (
                            <span className="description">
                                {truncateString(
                                    addToCalendarData.description,
                                    497,
                                )}
                            </span>
                        )}
                        {!!addToCalendarData.location && (
                            <span className="location">
                                {addToCalendarData.location}
                            </span>
                        )}
                        <span className="organizer">
                            {addToCalendarData.receipt_name}
                        </span>
                    </button>
                </>
            )}
        </div>
    ) : null;

EventDateAndLocation.propTypes = {
    displayEventDateAndLocation: PropTypes.bool.isRequired,
    displayFormattedEventDateString: PropTypes.bool.isRequired,
    displayFormattedEventLocationString: PropTypes.bool.isRequired,
    displaySeparatorDot: PropTypes.bool.isRequired,
    formattedEventDateString: PropTypes.string.isRequired,
    formattedEventLocationString: PropTypes.string.isRequired,
};

export default EventDateAndLocation;
